<template>
    <div class="container page-content mt-10">
        <animated-background-video/>
        <div class="row">
            <div class="col-12">
                <h1 class="page-heading text-dark dashbaord-heading">
                    {{ $t('dashboard.welcome') }}, {{ $store.state.user.username }}
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="shop">
                <router-link to="/shop" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.shop') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="marketplace">
                <router-link to="/marketplace" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.marketplace') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="boosters">
                <router-link to="/inventory" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.boosters') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="cards">
                <router-link to="/my-cards" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.cards') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="collection">
                <router-link to="/collections" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.collections') }}</span>
                </router-link>
            </div>

            <div v-if="$store.state.user.isAdmin" class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="decks">
                <router-link to="/decks" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.decks') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="trading">
                <router-link to="/trading" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.trading') }}</span>
                </router-link>
            </div>

            <!--            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="profile">-->
            <!--                <router-link :to="/u/+$store.state.user.username" class="btn btn-light w-100 dashboard-link">-->
            <!--                    <span>Profile</span>-->
            <!--                </router-link>-->
            <!--            </div>-->

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="social">
                <router-link to="/social" class="btn btn-light w-100 dashboard-link">
                    <span>{{ $t('dashboard.pages.social') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="sets">
                <router-link to="/gallery" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.gallery') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="quiz">
                <router-link to="/quiz" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.quiz') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="pokewordle">
                <router-link to="/pokewordle" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.pokewordle') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="slot">
                <router-link to="/slot" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.casino') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="search">
                <router-link to="/search" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.search') }}</span>
                </router-link>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="settings">
                <router-link to="/settings" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.settings') }}</span>
                </router-link>
            </div>

            <div v-if="$store.state.user.isAdmin" class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2 dashboard-link-wrapper" id="administration">
                <router-link to="/manage" class="btn btn-light w-100 dashboard-link link-wide">
                    <span>{{ $t('dashboard.pages.administration') }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

import CherryBlossoms from "../parts/CherryBlossoms.vue";
import AnimatedBackgroundVideo from "../parts/AnimatedBackgroundVideo.vue";

export default {
    name: "DemoDashboard",
    components: {AnimatedBackgroundVideo, CherryBlossoms},
    data() {
        return {};
    },
    mounted() {
        this.$store.commit('updateUserData');
    },
    computed: {},
    watch: {},
    methods: {
        //
    },
};
</script>


<style scoped lang="scss">
.dashboard-link {
    border: 1px solid slategrey;
    margin: 0 0 1em ;
    text-align: center;
    vertical-align: top;
    filter: drop-shadow(3px 3px rgba(0, 0, 0, 0.1));
    border-radius: 5%;
    padding-left: 0em;
    padding-right: 0em;
    padding-top: 0em;
    font-size: 1em;
    width: 90%;
    height: 10em;

    span {
        color: black;
    }

    .fa-solid {
        display: none;
        color: mediumturquoise;
        margin-top: .75rem;
        margin-bottom: .5rem;
        margin-left: .5em;
        font-size: 3em;
        max-width: 100%;
        height: 100%;
        filter: drop-shadow(3px 3px rgba(0, 0, 0, 0.33));

        &:hover {
            opacity: 0.8;
        }
    }

    .menu-icon {
        max-height: 6.5em;
        display: block;
        margin: .75em auto 0 auto;
        max-width: 100%;

        &:hover {
            opacity: 0.8;
        }
    }
}

.dashboard-link-wrapper {
    .dashboard-link {
        display: flex;
        align-content: flex-end;
        flex-wrap: wrap;
        justify-content: center;
    }

    .btn {
        text-transform: none;
        background-repeat: no-repeat;
        height: 15em;
        background-size: cover;
        background-position: center 36%;
        border-radius: 10px !important;
        text-shadow: 1px 1px #0a0a0a, -1px -1px #0a0a0a;
    }

    span {
        display: block;
        font-size: 1rem !important;
        font-weight: bold;
        margin-top: .75em;

        color: white;
    }

    &:is(#marketplace) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/market.jpg');
        }
    }

    &:is(#shop) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/shop-poca_sm.jpg');
            background-position: center center;
        }
    }

    &:is(#boosters) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/inventory-poca5_sm.jpg');
        }
    }

    &:is(#cards) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/mycards-poca_sm.jpg');
        }
    }

    &:is(#collection) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/collection-poca_sm.jpg');
        }
    }

    &:is(#decks) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/decks-poca_sm.jpg');
        }
    }

    &:is(#trading) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/trading-poca_sm.jpg');
        }
    }

    &:is(#social) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/social-poca_sm.jpg');
        }
    }

    &:is(#sets) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/gallery-poca.jpg');
            background-position: center 20%;
        }
    }

    &:is(#quiz) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/quiz-poca.jpg');
        }
    }

    &:is(#pokewordle) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/wordle-poca.jpg');
        }
    }

    &:is(#slot) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/casino-poca.jpg');
        }
    }

    &:is(#search) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/search-poca.jpg');
        }
    }

    &:is(#settings) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/settings-poca.jpg');
        }
    }

    &:is(#administration) {
        .btn {
            background-image: url('/assets/dipocaco/pocas/admin-poca.jpg');
            background-position: center 50%;
        }
    }
}
</style>